<template>
  <v-app>
    <head></head>
    <AppNavigation></AppNavigation>
    <BaseLoader v-if="isLoading"></BaseLoader>
    <AppDrawer></AppDrawer>
    <v-main class="view-background-color" style="min-width:320px">
      <router-view></router-view>
    </v-main>
    <AppModals></AppModals>
    <v-slide-y-transition>
      <BaseAlert
        v-if="alert != null"
        :alert="alert"
        :key="alert.time.getTime()"
      ></BaseAlert>
    </v-slide-y-transition>
    <v-dialog :value="askToCompleteProfileView" persistent max-width="380">
      <v-card>
        <v-card-title class="text-h5 text--primary word-break-break-word">
          Complète ton profil
        </v-card-title>

        <v-card-text>
          Si tu possèdes des blogs ou des chaînes YouTube, renseigne-les en cliquant
          sur le bouton "Je complète mon profil".
        </v-card-text>

        <v-card-actions class="d-flex flex-wrap justify-space-around">
          <v-btn
            color="grey"
            text
            @click="$store.dispatch('navigation/closeAskToCompleteProfileView')"
          >
            Plus tard
          </v-btn>
          <router-link :to="{ name: 'account/creator/new' }">
            <v-btn
              color="primary"
              depressed
              @click="
                $store.dispatch('navigation/closeAskToCompleteProfileView')
              "
            >
              Je complète mon profil
            </v-btn>
          </router-link>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import AppDrawer from "./core/components/AppDrawer";
import AppNavigation from "./core/components/AppNavigation";
import AppModals from "./core/components/AppModals";
import BaseLoader from "./core/components/BaseLoader";
import BaseAlert from "./core/components/BaseAlert";

import { mapState, mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    AppDrawer,
    AppNavigation,
    AppModals,
    BaseLoader,
    BaseAlert
  },
  computed: {
    ...mapState({
      isLoading: state => state.loading,
      alert: state => state.alert,
      askToCompleteProfileView: state =>
        state.navigation.askToCompleteProfile.view,
      creator: state => state.myProfileView.creator
    }),
    ...mapGetters({
      isProfileCompleted: "isProfileCompleted",
      loggedIn: "account/loggedIn"
    })
  },

  watch: {
    isLoggedIn(v) {
      v ? (this.localStorageHasBeenUpdated = true) : null;
    }
  }
};
</script>
<style lang="scss">
@import "./styles/global.scss";
</style>
